import React from 'react';
import { useTranslation } from 'react-i18next';
import style from '../style/components/ErrorPage.module.scss';
import legacyLogo from '../img/idme-logo.svg';
import useFragno1 from '../fragno1/useFragno1';
import IdMeLogo from '../fragno1/ui/IdMeLogo';
import { ID_ME_MARK_ASPECT } from '../fragno1/ui/idMeMark';

// As wide as the legacy logo (2rem tall, 167.2 × 59.8 viewBox, about 89px wide). The mark is
// narrower, so matching the legacy height would make it look smaller.
const LEGACY_LOGO_WIDTH = 32 * (167.2 / 59.8);
const FRAGNO1_LOGO_HEIGHT = LEGACY_LOGO_WIDTH / ID_ME_MARK_ASPECT;

const ErrorPage = () => {
  const { t } = useTranslation();
  const fragno1 = useFragno1();

  return (
    <div>
      <div className={style.top}>
        <h1>
          {fragno1 ? (
            <a href="https://id.me" className={style.fragno1Logo}>
              <IdMeLogo
                ariaLabel={t('shared.idmeLogoAlt')}
                height={FRAGNO1_LOGO_HEIGHT}
              />
            </a>
          ) : (
            <a href="https://id.me">
              <img alt={t('shared.idmeLogoAlt')} src={legacyLogo} />
            </a>
          )}
        </h1>
      </div>
      <div className={style.bottom}>
        <div className={style.content}>
          <h2>Something Went Wrong</h2>
          <p>
            We are unable to process your request. We have been notified of the
            problem and will do our best to make sure it doesn't happen again!
          </p>
          <p>
            If you believe you have received this message in error, please&nbsp;
            <a href={window.location.pathname}>try again</a>
            &nbsp;or visit our&nbsp;
            <a href="https://help.id.me/">customer support knowledge base.</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
